import { IState } from '../shared/models/state';
import { createSelector } from '@ngrx/store';
import {
  CHANGE_CURRENT_STATE,
  CHANGE_STATE_META,
  CHANGE_STATES_FLOW_IF_EMPTY, FINISH_FIRST_STEPS,
  FirstStepsAction
} from './first-steps.actions';

export type State = string;

export interface FirstStepsState {
  currentState?: State;
  statesFlow?: State[];
  stateMeta?: any;
}

export const initialState: FirstStepsState = { currentState: 'web-call-installation' };

export function firstStepsReducer(state: FirstStepsState = initialState, action: FirstStepsAction): FirstStepsState {
  switch (action.type) {
    case CHANGE_CURRENT_STATE:
      return { ...state, currentState: action.payload };
    case CHANGE_STATE_META:
      return { ...state, stateMeta: action.payload };
    case CHANGE_STATES_FLOW_IF_EMPTY:
      return { ...state, statesFlow: state.statesFlow || action.payload };
    case FINISH_FIRST_STEPS:
      return { ...state, currentState: null };
    default:
      return state;
  }
}

const getCurrentState = (state: FirstStepsState): State => state.currentState;
const getStatesFlow = (state: FirstStepsState): State[] => state.statesFlow;

const rootSelector = (state: IState): FirstStepsState => state.firstSteps;

export const getCurrentStateSelector = createSelector(rootSelector, getCurrentState);
export const getStatesFlowSelector = createSelector(rootSelector, getStatesFlow);
